'use strict';

function Territory (domain) {
  this.localityDistricts = domain.get('localityDistricts').toJS() || [];
  this.regionDistricts = domain.get('regionDistricts').toJS() || [];
  this.subways = domain.get('subways').toJS() || [];
  this.store = domain.get('territory').toJS();

  this.countSubway = this.subways.length;
  this.countRegion = this.regionDistricts.length;
  this.countLocality = this.localityDistricts.length;
  this.countMicro = this.localityDistricts.reduce((acc, item) => {
    const curr = item.microDistricts && item.microDistricts.length;
    return curr ? curr + acc : acc;
  }, 0);
}

const proto = Territory.prototype;

proto.getCountSubways = function () {
  return this.countSubway;
};

proto.getCountLocalityDistricts = function () {
  return this.countLocality;
};

proto.getCountRegionDistricts = function () {
  return this.countRegion;
};

proto.getCountMicroDistrict = function () {
  return this.countMicro;
};

proto.isEmpty = function () {
  return (
    this.getCountLocalityDistricts() +
    this.getCountRegionDistricts() +
    this.getCountMicroDistrict() +
    this.getCountSubways()
  ) === 0;
};

proto.getSubwayById = function (id) {
  let subway = null;
  const name = this.store['s_' + id];
  if (name) {
    subway = {id, name};
  }

  return subway;
};

proto.getSubways = function () {
  return this.subways.map(id => this.getSubwayById(id));
};

/**
 * Возвращает район города по ID
 * @param id
 * @returns {string}
 */
proto.getLocalityDistrictById = function (id, withMicroDistricts) {
  let localityDistrict = null;
  const name = this.store['l_' + id];
  if (name) {
    localityDistrict = {id, name};
  }

  if (withMicroDistricts) {
    localityDistrict.microDistricts = this.getMicroDistricts(id);
  }

  return localityDistrict;
};

/**
 * Возвращает район по микрорайону
 * @param id
 * @param withMicroDistricts
 * @returns {*}
 */
proto.getLocalityDistrictByMicroDistrictId = function (id, withMicroDistricts) {
  const length = this.localityDistricts.length;
  for (let i = 0; i < length; i += 1) {
    const district = this.localityDistricts[i];
    const microDistricts = district.microDistricts;

    if (microDistricts) {
      const l = microDistricts.length;
      for (let j = 0; j < l; j += 1) {
        if (id === microDistricts[j]) {
          return this.getLocalityDistrictById(district.id, withMicroDistricts);
        }
      }
    }
  }

  return null;
};

/**
 * Все районы города
 * @returns {*}
 */
proto.getLocalityDistricts = function (withMicroDistricts) {
  return this.localityDistricts.map(item => {
    return this.getLocalityDistrictById(item.id, withMicroDistricts);
  });
};

proto.getMicroDistrictById = function (id, localityDistrictId) {
  const name = this.store['m_' + id];
  if (name) {
    return {
      id,
      name,
      localityDistrictId
    };
  }

  return null;
};

proto.getMicroDistricts = function (localityDistrictId) {
  for (let i = 0; i < this.countLocality; i += 1) {
    if (this.localityDistricts[i].id === localityDistrictId) {
      if (this.localityDistricts[i].microDistricts) {
        return this.localityDistricts[i].microDistricts
          .map(id => this.getMicroDistrictById(id, localityDistrictId));
      }
    }
  }

  return [];
};

proto.getRegionDistrictById = function (id) {
  const name = this.store['r_' + id];
  if (name) {
    return {
      id,
      name
    };
  }

  return null;
};

proto.getRegionDistricts = function () {
  return this.regionDistricts.map(id => {
    return this.getRegionDistrictById(id);
  });
};

export default Territory;



// WEBPACK FOOTER //
// ./src/classes/geo/territory.js